// perfectScoreBanner.js
var PerfectScoreBanner = pc.createScript('perfectScoreBanner');

PerfectScoreBanner.attributes.add('currentStar', {type: 'entity'});
PerfectScoreBanner.attributes.add('winScore', {type: 'entity'});
PerfectScoreBanner.attributes.add('extraPointText', {type: 'entity'});

PerfectScoreBanner.prototype.initialize = function() {
   
    PerfectScoreBanner.instance = this;
    this.entity.on("destroy", this.OnDestroy,this);
};

PerfectScoreBanner.prototype.isLostStatus = function (inputVal) {

    if (inputVal == true) {
        setTimeout(function () {
            PerfectScoreBanner.instance.entity.children[1].enabled = false;
        }, 3000, this);
    }
};

PerfectScoreBanner.prototype.extraPointStartAnimation = function() {
    let extraScoreText = this.extraPointText;
    this.extraPointText
    .tween(this.extraPointText.getLocalScale())
    .to(new pc.Vec3(1.3, 1.3, 1.3), 0.5, pc.SineOut)
    .on('complete', function(){ PerfectScoreBanner.instance.extraPointEffect(extraScoreText);}, this)
    .start();
};

PerfectScoreBanner.prototype.extraPointChallengeStartAnimation = function() {
    let extraScoreText = this.extraPointText;
    this.extraPointText
    .tween(this.extraPointText.getLocalScale())
    .to(new pc.Vec3(1.3, 1.3, 1.3), 0.5, pc.SineOut)
    .on('complete', function(){ PerfectScoreBanner.instance.extraPointChallengeEffect(extraScoreText);},this)
    .start();
};

PerfectScoreBanner.prototype.extraPointEffect = function(inputUI){
    inputUI.tween(inputUI.getLocalScale()).to(new pc.Vec3(1.0, 1.0, 1.0), 0.5, pc.SineOut).on('complete', PerfectScoreBanner.instance.dropStars()).start();
};

PerfectScoreBanner.prototype.extraPointChallengeEffect = function(inputUI){
    inputUI.tween(inputUI.getLocalScale()).to(new pc.Vec3(1.0, 1.0, 1.0), 0.5, pc.SineOut).start();
};

PerfectScoreBanner.prototype.dropStars = function() {
    let starAnimCount = 1;

    let score = this.entity.children[3];
    setTimeout(function () {
        for (i = 0; i < parseInt(score.element.text); i++) {

            if ((i % 10) == 0) {
                PerfectScoreBanner.instance.addExtraScore(starAnimCount);
                starAnimCount = starAnimCount + 1;
            }

            PerfectScoreBanner.instance.addExtraScoreText(i);
        }
    }, 1000, this);
};

PerfectScoreBanner.prototype.addExtraScore = function (input) {

    let animationDt = 1000 / (parseInt(this.entity.children[3].element.text) / 10);

    setTimeout(function () {

        let item = PerfectScoreBanner.instance.currentStar.clone();
        let star = PerfectScoreBanner.instance.currentStar;
        star.parent.addChild(item);
        item.enabled = true;

    }, animationDt * input, this);
};

PerfectScoreBanner.prototype.addExtraScoreText = function (input) {

    let animationDt = 1000 / parseInt(this.entity.children[3].element.text);
    
    let extraScoreCount = this.entity.children[3];
    let extraScoreText = this.entity.children[2];
    let winScoreText = this.winScore;

    setTimeout(function () {
        
        extraScoreCount.element.text = parseInt(extraScoreCount.element.text)-1;

        if (parseInt(extraScoreCount.element.text) == 0) {
            extraScoreText.enabled = false;
        }
        else {
            extraScoreText.element.text = "Extra " + extraScoreCount.element.text + " stars!";
        }

        let userScore = winScoreText.element.text.split('SCORE: ');
        let incrementalScore = parseInt(userScore[1])+1;
        winScoreText.element.text = 'SCORE: ' + incrementalScore;
        
    }, animationDt * input, this);
};

PerfectScoreBanner.prototype.OnDestroy = function(){
  
    this.app.off('gameManager:updatestatus',this.Status,this);
    this.entity.off("destroy", this.OnDestroy,this);
};

